import { render, staticRenderFns } from "./AdminSuperMobileSupport.vue?vue&type=template&id=095987e2&"
import script from "./AdminSuperMobileSupport.vue?vue&type=script&lang=js&"
export * from "./AdminSuperMobileSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports